import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthDavesaV2Service } from '../auth-davesa-v2.service';
import { UserRoleEnum } from 'app/core/enum/userRole.enum';

export const RoleRedirectGuard: CanActivateFn = async () => {
  const authService = inject(AuthDavesaV2Service);
  const router = inject(Router);

  // Ensure user role is loaded
  await authService.ensureUserRoleLoaded();
  
  // Check if user is an organization user
  const decodedToken = authService.decodedToken();
  const isOrganizationUser = decodedToken?.isOrganization === true;

  if (isOrganizationUser) {
    return router.parseUrl('/organizations');
  }

  const userRole = authService.loginUserRole();

  if (userRole === UserRoleEnum.financeAdministrator) {
    return router.parseUrl('/finance/finance-dashboard');
  } else {
    return router.parseUrl('/dashboards/clinic');
  }
}; 